import VerificationPopup from './VerificationPopup';
import VerificationPopupContainer from './VerificationPopup.container';
export default VerificationPopupContainer(VerificationPopup);
